export const USER_PROFILES = {
  ADMIN_PROFILES: ['master', 'supervisor', 'administrator', 'superadmin'],
  AGENT_PROFILES: ['agent', 'supervisor', 'administrator', 'superadmin', 'master'],
};
